<template>
  <div
    id="RegisterEmail"
    class="authentication-container"
    :class="{'authentication-container-mobile': isMobileSize}"
  >

    <!-- LEFT SIDE -->

    <left-side v-if="!isMobileSize"/>

    <!-- RIGHT SIDE -->

    <div class="right-side">

      <!-- STEP 1 -->

      <div
        class="step-1"
        :class="{'mobile': isMobileSize}"
        v-if="!response"
      >

        <!-- TITLE -->

        <div class="title">
          <h3 class="title-header">Register Email</h3>
        </div>

        <!-- INPUT -->
        <form
          class="content form"
          @submit.prevent="invite"
        >
          <div class="inputs">
            <div class="input-container">
              <label
                for="email"
                class="label"
              >Please enter your email to continue registration</label>
              <input
                id="email"
                type="email"
                class="primary-input"
                v-model="$v.credentials.email.$model"
                :class="{error: $v.credentials.email.$error}"
              >
              <validation-message
                :validation="$v.credentials.email"
                :metadata="memberMetadata.fields.email"
              />
            </div>
          </div>

          <!-- ACTIONS -->

          <div class="actions">
            <CoreButton
              type="submit"
              :disabled="$v.credentials.$invalid || !credentials.email"
              :loading="isLoading"
            >
              Send
            </CoreButton>
          </div>
        </form>
      </div>
      <div
        class="step-2"
        v-if="response"
        :class="{'mobile': isMobileSize}"
      >
        <div class="title">
          <h3 class="title-header">Send you email</h3>
        </div>
        <div class="content dialog-message">
          <p>We have sent email to <span class="response"> {{ response.email }} </span> to register. After receiving
            the email follow the link provided.
          </p>
        </div>
        <div>
          <p class="p-left-50">
            Haven't got any mails yet? <span
              class="link"
              @click="invite"
            >Resend email</span>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import server, { createValidator } from './../server'
import { mixin as clickout } from 'vue-clickout'
import { DolphinService } from '../utils/request'
import { createToastNotification } from '../utils/toast'
import { WaitStates } from '../utils/vuewait'
import { DEFAULT_SCOPES, DEFAULT_APPLICATION_ID, DEFAULT_REDIRECT_URL } from '../settings'
const jwtDecode = require('jwt-decode')

const CoreButton = () => import(
  /* webpackChunkName: "CoreButton" */ './../components/Core/CoreButton.vue'
)
const LeftSide = () => import(
  /* webpackChunkName: "LeftSide" */ './../components/LeftSide'
)
const ValidationMessage = () => import(
  /* webpackChunkName: "ValidationMessage" */ './../components/ValidationMessage'
)

export default {
  mixins: [clickout],
  name: 'RegisterEmail',
  data () {
    return {
      scopes: this.$route.query.scopes || DEFAULT_SCOPES.join(','),
      redirectUri: this.$route.query.redirectUri || DEFAULT_REDIRECT_URL,
      roles: [],
      applicationId: this.$route.query.applicationId || DEFAULT_APPLICATION_ID,
      organizationId: this.$route.query.organizationId,
      token: this.$route.query.t_,
      credentials: {
        email: null
      },
      memberMetadata: server.metadata,
      response: null
    }
  },
  validations () {
    return {
      credentials: {
        email: createValidator(this.memberMetadata.fields.email)
      }
    }
  },
  computed: {
    isLoading () {
      return this.$wait.is(WaitStates.REGISTER_EMAIL_LOADING)
    },

    isMobileSize () {
      return window.innerWidth <= 768
    }
  },
  methods: {
    async invite () {
      const form = {
        email: this.credentials.email,
        roles: this.roles,
        scopes: this.scopes,
        applicationId: this.applicationId,
        redirectUri: this.redirectUri,
        invitationToken: this.token
      }
      this.$wait.start(WaitStates.REGISTER_EMAIL_LOADING)
      const { status, statusText, data } = await DolphinService({
        url: `organizations/${this.organizationId}/invitations`,
        method: 'CREATE',
        data: form
      })
      this.$wait.end(WaitStates.REGISTER_EMAIL_LOADING)
      if (status === 200) {
        createToastNotification(statusText, { type: 'success', position: 'bottom' })
        this.response = data
      }
    }

  },
  beforeMount () {
    const memberData = jwtDecode(this.token)
    this.organizationId = memberData.organizationId
    this.roles = memberData.roles
  },
  components: {
    LeftSide,
    ValidationMessage,
    CoreButton
  }
}
</script>
